import styled from 'styled-components';

export const StyledText = styled.div`
    flex-basis: 70%;
`;
